// extracted by mini-css-extract-plugin
export default {"container":"AddNewCard_container__MMeJH","subContainer":"AddNewCard_subContainer__4Ygag","leftArrow":"AddNewCard_leftArrow__Y1oS6"};